// removed by extract-text-webpack-plugin
module.exports = {"recipeTitleImage":"G6eff44 Gfbbf38","recipeImage":"Gd8c12a","recipeTitle":"G45313e Gfbbf38","recipeRadioButtonGroup":"G417e1e"};